import { render, staticRenderFns } from "./LeakageCauseDateWorksBeforeQuestion.vue?vue&type=template&id=1533d882&scoped=true"
import script from "./LeakageCauseDateWorksBeforeQuestion.vue?vue&type=script&lang=ts"
export * from "./LeakageCauseDateWorksBeforeQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1533d882",
  null
  
)

export default component.exports